import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { dummyListProduk } from "../dummy-data";
import { Button } from "primereact/button";
import { FaKitchenSet } from "react-icons/fa6";
import ProductImageCarousel from "../components/ProductImageCarousel";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";
import { format } from "date-fns";
import GoogleMapsPicker from "../../../components/GoogleMapsPicker";

const ProdukPage = () => {
  const { id } = useParams();
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();
  const uiContext = useContext(UiContext);

  const [produk, setProduk] = useState({
    nama: "-",
    harga: 0,
    data_produk_kategori: { nama: "" },
    data_toko: { nama: "" },
    keterangan: "",
  });
  const [showTokoDetail, setShowTokoDetail] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);

  // useeffect section
  useEffect(() => {
    fetchProduk(id);
  }, []);

  // call api section
  const fetchProduk = async (produkId) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/produk/one/${produkId}`,
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          setProduk(data);
          const _galleryImages = [];
          if (data.gambar) {
            _galleryImages.push({
              image: data.gambar,
              alt: "alt-gambar-0",
              title: "title-gambar-0",
            });
          }
          if (data.data_produk_gambars) {
            for (let i = 0; i < data.data_produk_gambars.length; i++) {
              _galleryImages.push({
                image: data.data_produk_gambars[i].gambar,
                alt: `alt-gambar-${i + 1}`,
                title: `title-gambar-${i + 1}`,
              });
            }
          }
          setGalleryImages(_galleryImages);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });

    // const _produk = dummyListProduk.find((produk) => produk.id == produkId);
    // setProduk(_produk);
    // const _galleryImages = [];
    // if (_produk.gambar) {
    //   _galleryImages.push({
    //     image: _produk.gambar,
    //     alt: "alt-gambar-0",
    //     title: "title-gambar-0",
    //   });
    // }
    // if (_produk.data_produk_gambar) {
    //   for (let i = 0; i < _produk.data_produk_gambar.length; i++) {
    //     _galleryImages.push({
    //       image: _produk.data_produk_gambar[i].gambar,
    //       alt: `alt-gambar-${i + 1}`,
    //       title: `title-gambar-${i + 1}`,
    //     });
    //   }
    // }
    // setGalleryImages(_galleryImages);
  };

  // other function section

  // ui handler section

  // custom ui section

  const DetailRow = ({ className, label, value }) => {
    return (
      <div className={`col-start-start gap-1 ${className ?? "-"}`}>
        <span className="text-[0.6rem] font-semibold text-slate-400 tracking-wide leading-tight">
          {label}
        </span>
        <span className=" text-slate-700 font-semibold leading-tight">
          {value}
        </span>
      </div>
    );
  };

  const DetailKategori = ({ className, label, kategoris }) => {
    return (
      <div className={`col-start-start gap-1 ${className ?? "-"}`}>
        <span className="text-[0.6rem] font-semibold text-slate-400 tracking-wide leading-tight">
          {label}
        </span>
        <span className=" text-slate-700 font-semibold leading-tight">
          {kategoris?.map((item, key) => {
            return item.nama + (key < kategoris.length - 1 ? ", " : "");
          })}
        </span>
      </div>
    );
  };

  return (
    <div className="col-start-start gap-1">
      <div className="col-start-start bg-white w-full shadow-xs pb-4">
        <div className="row-start-start pt-3 pb-2 px-3 sm:px-5 ">
          <Link className="px-1" to={-1}>
            <i className="pi pi-arrow-left text-slate-600" />
          </Link>
        </div>

        <div className="col-start-start w-full">
          <div className="w-full h-auto px-0">
            <ProductImageCarousel items={galleryImages} />
          </div>

          <div className="col-start-start px-3 sm:px-5">
            <span className="text-xl font-semibold text-slate-700 py-2">
              {produk?.nama}
            </span>

            <div className="col-start-start gap-3">
              {/* <DetailRow
                className="pt-1"
                label="KATEGORI"
                value={produk?.data_produk_kategori?.nama}
              /> */}
              <DetailKategori
                className="pt-1"
                label="KATEGORI"
                kategoris={produk?.data_produk_kategoris}
              />
              <DetailRow
                label="HARGA"
                value={(produk.harga ? produk.harga : 0).toLocaleString(
                  "id-ID"
                )}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-2">
        <div className="row-between-center w-full gap-3">
          <div className="row-start-center gap-3">
            <FaKitchenSet className="text-slate-700 text-xl" />
            <span className="text-slate-700 font-semibold leading-tight">
              {produk.data_toko
                ? produk.data_toko.nama_toko
                : produk.nama_toko ?? ""}{" "}
            </span>
          </div>
          <Button
            className="max-w-[2rem] max-h-[2rem] !p-0 border-slate-400 text-slate-500"
            outlined
            rounded
            icon={`pi ${showTokoDetail ? "pi-chevron-up" : "pi-chevron-down"}`}
            onClick={() => setShowTokoDetail((prev) => !prev)}
          />
        </div>
        {showTokoDetail && (
          <div className="col-start-start gap-3">
            <DetailRow
              label="PEMILIK"
              value={
                produk.data_toko
                  ? produk.data_toko.nama_pemilik
                  : produk.nama_pemilik
              }
            />
            <DetailRow
              className="pt-3"
              label="ALAMAT"
              value={produk.data_toko ? produk.data_toko.alamat : produk.alamat}
            />
            {produk.data_toko && produk.data_toko.alamat && (
              <div className="bg-red-100 w-full">
                <GoogleMapsPicker
                  handleGetCoordinate={() => {}}
                  latitude={produk.data_toko.latitude}
                  longitude={produk.data_toko.longitude}
                  canEdit={false}
                />
              </div>
            )}
            <DetailRow
              className={"pt-1"}
              label="JAM BUKA"
              value={
                produk.data_toko ? produk.data_toko.jam_buka : produk.jam_buka
              }
            />
            <DetailRow
              label="TELEPON"
              value={
                produk.data_toko ? produk.data_toko.telepon : produk.telepon
              }
            />
            {/* <div className="row-start-center pt-1">
              <Button
                className="text-slate-500 max-h-[2rem]"
                outlined
                icon="pi pi-pencil"
                label="Edit Data Toko"
                onClick={() => {}}
              />
            </div> */}
          </div>
        )}
      </div>

      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pb-4 py-4 gap-2 leading-snug">
        {(produk.keterangan ?? "").split("\n").map((item, key) => {
          return (
            <span key={`keterangan-${key}`} className="text-slate-700">
              {item}
            </span>
          );
        })}
      </div>

      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pb-4 py-4 gap-2 leading-snug">
        {(produk.bahan ?? "").split("\n").map((item, key) => {
          return (
            <span key={`bahan-${key}`} className="text-slate-700">
              {item}
            </span>
          );
        })}
      </div>
      <div className="row-start-start bg-white w-full shadow-xs px-3 sm:px-5 pb-10 py-4 leading-snug text-xs  gap-x-10 flex-wrap italic text-slate-500 ">
        <span>
          {" "}
          Created By: {produk.input_by ?? "-"}{" "}
          {produk.created_at
            ? `(${format(new Date(produk.created_at), "dd-MM-yyyy HH:mm")})`
            : ""}{" "}
        </span>
        <span>
          {" "}
          Last Updated By: {produk.edit_by ?? "-"}{" "}
          {produk.updated_at
            ? `(${format(new Date(produk.updated_at), "dd-MM-yyyy HH:mm")})`
            : ""}{" "}
        </span>
      </div>
    </div>
  );
};

export default ProdukPage;
